//action types
export const PREFERENCES_GET_PREFERENCES_REQUEST = 'PREFERENCES_GET_PREFERENCES_REQUEST';
export const PREFERENCES_GET_PREFERENCES_RESULT = 'PREFERENCES_GET_PREFERENCES_RESULT';
export const PREFERENCES_GET_PREFERENCES_RESULT_UPDATE = 'PREFERENCES_GET_PREFERENCES_RESULT_UPDATE';
export const PREFERENCES_SAVE_PREFERENCE = 'PREFERENCES_SAVE_PREFERENCE';
export const PREFERENCES_UPDATE_PREFERENCES_OTHER = 'PREFERENCES_UPDATE_PREFERENCES_OTHER';
export const PREFERENCES_CLEAR_RETURNED_KEY = 'PREFERENCES_CLEAR_RETURNED_KEY';